module.exports = __webpack_public_path__ + "img/fangkuanzhong.174a4821.png";